module.exports = __webpack_public_path__ + "static/media/Promo (2).cbee100a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-inalambrico/Promo (2).svg
// module id = 205
// module chunks = 0